import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from 'react-bootstrap';

type Props = {
  targets: {
    name: string;
    count: number;
  }[];
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const RSCatalogTargetSelect = ({ targets, onChange }: Props) => (
  <Form.Group>
    <Form.Label>
      <FontAwesomeIcon icon={faGlobe} /> 観測対象で絞り込む
    </Form.Label>
    <Form.Select onChange={onChange}>
      <option></option>
      {targets.map((target) => (
        <option key={target.name} value={target.name}>
          {target.name} ({target.count})
        </option>
      ))}
    </Form.Select>
  </Form.Group>
);
